import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Dimensions, StyleSheet } from 'react-native'

import WaitingBoardChips from '../../../assets/waiting-board-chips.svg'
import { DS } from '../../../design-system'
import { useTimer } from '../../../hooks/useTimer'
import { useStore } from '../../../models'

type ChipsWaitingGameLayoutProps = {
  hideChips?: boolean
}

export const ChipsWaitingGameLayout = observer(({ hideChips }: ChipsWaitingGameLayoutProps) => {
  const {
    game: { timerCountdown, setTimerCountDown, isGamePlaying }
  } = useStore()
  const timerCallback = () => {
    console.log('timerCallback')
  }
  const { time, setInitialTime } = useTimer({ callback: timerCallback })

  const { height: HEIGHT } = Dimensions.get('window')
  const isSmallerDevice = HEIGHT <= 667
  const isXSmallerDevice = HEIGHT <= 640

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (timerCountdown) {
      setInitialTime(timerCountdown)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timerCountdown])

  useEffect(() => {
    if (isGamePlaying) {
      setTimerCountDown(undefined)
      setInitialTime(0)
    }
  }, [isGamePlaying, setInitialTime, setTimerCountDown])

  if (!time) return null

  return (
    <DS.Frame alignItems="center">
      {!hideChips && <WaitingBoardChips width={isSmallerDevice ? 45 : 72} />}
      <DS.Text
        variant="Heading 4/Regular"
        color="Brand/Cream"
        style={[
          { alignSelf: 'center', marginTop: isSmallerDevice ? -10 : isXSmallerDevice ? 20 : 0 },
          isXSmallerDevice && styles.smallText
        ]}
      >
        Game starts
      </DS.Text>
      <DS.Frame row gap={'8'}>
        <DS.Text variant="Heading 4/Regular" color="Brand/Cream" style={isXSmallerDevice && styles.smallText}>
          in
        </DS.Text>
        <DS.Frame style={styles.timerContainer}>
          <DS.Text variant="Body Medium/Medium" style={isXSmallerDevice && styles.smallText}>
            {time}s
          </DS.Text>
        </DS.Frame>
      </DS.Frame>
    </DS.Frame>
  )
})

const styles = StyleSheet.create({
  timerContainer: {
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 24,
    paddingVertical: 2,
    paddingHorizontal: 8,
    justifyContent: 'center'
  },
  smallText: {
    fontSize: 16
  }
})
